import { useEffect } from 'react';

import { getBrand } from '../../lib/brandClient.js';

/**
 * <BrandFavicon /> — sets the document favicon from brand.config.json. Render once
 * at the app root (the Vite html plugin already injects <link rel="icon"> at build
 * time, but this hook updates the favicon dynamically on hot brand swaps).
 */
export function BrandFavicon(): null {
  useEffect(() => {
    const cfg = getBrand();
    const links = Array.from(document.head.querySelectorAll<HTMLLinkElement>('link[rel="icon"]'));
    for (const link of links) {
      link.href = cfg.favicon;
    }
  }, []);
  return null;
}
